/**
 * Dashboard data refresh settings.
 *
 * Preview and the published view always read the database when a dashboard is
 * opened; `canvas.autoRefreshSeconds` additionally re-reads it on an interval
 * while the dashboard stays open (Design tab, nothing selected → Data refresh).
 */

/** Shortest auto-refresh interval: each refresh re-runs every widget's query. */
export const MIN_AUTO_REFRESH_SECONDS = 10;

/**
 * A stored / typed auto-refresh interval as whole seconds: 0 (off) for
 * nothing, zero, a negative or a non-number; otherwise at least
 * {@link MIN_AUTO_REFRESH_SECONDS}.
 */
export function autoRefreshSecondsOf(value: unknown): number {
  const seconds = typeof value === 'string' && value.trim() === '' ? NaN : Number(value);
  if (!Number.isFinite(seconds) || seconds <= 0) return 0;
  return Math.max(MIN_AUTO_REFRESH_SECONDS, Math.round(seconds));
}
